import { forwardRef } from 'react';

import { StyledButton, StyledSlot } from './Button.styles';
import type { Props } from './Button.types';

export const Button = forwardRef<HTMLButtonElement, Props>(
  (
    { type = 'button', size = 'medium', format = 'auto', asChild, ...rest },
    ref
  ) => {
    const Component = asChild ? StyledSlot : StyledButton;

    return (
      <Component type={type} size={size} format={format} ref={ref} {...rest} />
    );
  }
);

Button.displayName = 'Button';
